// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"TruncateText_textContainer__b_kf_","truncate":"TruncateText_truncate__aUHfi","expanded":"TruncateText_expanded__szcbh","more":"TruncateText_more__uiLHC"};